import { render } from "./a-header.vue?vue&type=template&id=05121127&scoped=true"
import script from "./a-header.vue?vue&type=script&lang=js"
export * from "./a-header.vue?vue&type=script&lang=js"

import "./a-header.vue?vue&type=style&index=0&id=05121127&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/praxisti/htdocs/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05121127"]])

export default __exports__